import * as React from "react";

function SvgUnwaffle(props, ref) {
  return (
    <svg
      id="Unwaffle_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 400 400"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".Unwaffle_svg__st1,.Unwaffle_svg__st2{fill:none;stroke:#ccc;stroke-width:20}.Unwaffle_svg__st2{stroke:#2196ff}"
        }
      </style>
      <g id="Unwaffle_svg__svg_logo">
        <path
          className="Unwaffle_svg__st1"
          d="M25 21h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5H25c-2.76 0-5-2.24-5-5V26c0-2.76 2.24-5 5-5zM25 121h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5H25c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z"
        />
        <path
          className="Unwaffle_svg__st2"
          d="M25 221h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5H25c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5zM25 321h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5H25c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z"
        />
        <path
          className="Unwaffle_svg__st1"
          d="M125 21h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5V26c0-2.76 2.24-5 5-5zM125 121h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5zM125 221h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z"
        />
        <path
          className="Unwaffle_svg__st2"
          d="M125 321h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z"
        />
        <path
          className="Unwaffle_svg__st1"
          d="M225 21h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5V26c0-2.76 2.24-5 5-5zM225 121h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z"
        />
        <path
          className="Unwaffle_svg__st2"
          d="M225 221h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5zM225 321h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z"
        />
        <path
          className="Unwaffle_svg__st1"
          d="M325 21h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5V26c0-2.76 2.24-5 5-5z"
        />
        <path
          className="Unwaffle_svg__st2"
          d="M325 121h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5zM325 221h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5zM325 321h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgUnwaffle);
